export default __webpack_public_path__ + "static/media/Info_Recogido_por_la_transportadora_SIN_recaudo_Envío_Tradicional.2ec7d94a.png";